<style>
  .colorSuccess{
    color: #67c23a;
    font-size: 14px;
  }
</style>
<template>
  <div class="send-box">
    <div class="shade-box">
      <div class="shade-content shade-width">
        <p class="dialog-title-bg">指定模板发送短信
          <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="resetMessageForm('sendMsgForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="sendForm" ref="sendMsgForm" label-width="120px" class="demo-dynamic">
            <el-form-item label="短信类型" prop="isMarket" >
              <el-radio-group v-model="sendForm.isMarket" >
                <el-radio :label="1">普通</el-radio>
                <el-radio :label="2">营销</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="订单号" prop="orderNo" v-if="sendForm.isMarket == 2">
              <el-input v-model="sendForm.orderNo" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item label="批次号" prop="reqNo" v-if="sendForm.isMarket == 2">
              <el-input v-model="sendForm.reqNo" placeholder="请输入批次号"></el-input>
            </el-form-item>
            <el-form-item label="签名" prop="signName" :rules="{required: true, message: '签名不能为空', trigger: 'change'}">
              <el-select v-model="sendForm.signName" placeholder="请选择签名" @change="signNameChange">
                <el-option v-for="item in autographData"
                  :key="item.id"
                  :label="item.signName"
                  :value="item.signName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-for="(domain, index) in sendForm.params"
              :label="'模板参数' + (index + 1)"
              :key="domain.key"
              :prop="'params.' + index + '.value'">
              <!--:rules="{required: true, message: '模板参数不能为空', trigger: 'blur'}">-->
              <el-input v-model="domain.value" class="width7" placeholder="请输入模板" maxlength="12" @change="putDomainInRematn(index)"></el-input><el-button type="info" @click.prevent="removeDomain(index)">删除</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="addDomain">新增模板参数</el-button>
            </el-form-item>
            <el-form-item label='短信预览'>
              <el-input v-model="mouldContent" type="textarea" readonly="readonly" resize="none" maxlength="450" :autosize="{ minRows: 5, maxRows: 10}"></el-input>
              <p class="colorBBB">已输入 <span class="text-red">{{remain}}</span> 个字,预计发送条数约为 <span class="text-red"> {{num}} </span></p>
              <p class="text-red">（实际发送时，如有模板变量会影响计费条数，请特别关注）</p>
            </el-form-item>
            <el-form-item label="发送对象">
              <el-upload
                class="upload-demo"
                accept=".xls"
                ref="upload"
                action="http(s)://upload-z2.qiniup.com"
                :show-file-list="false"
                :http-request="uploadQiniu"
                :on-change="beforeUpload"
                :limit="1"
                :auto-upload="false"
                :multiple='false'>
                <el-button>选取文件</el-button>
                <div v-if="textTips" slot="tip" class="el-upload__tip colorSuccess">文件选取成功</div>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <p class="colorBBB">单次最大上传1M，请使用指定模板 <a :href="url + '/excel/downLoadExcelModule'">模板下载</a></p>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('sendMsgForm')" :disabled="disabled">立即发送</el-button>
              <el-button @click="resetMessageForm('sendMsgForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
import http from '../../server/http'
import axios from 'axios'
export default {
  props: {
    sendData:{
      type: Object
    }
  },
  name: "send",
  data(){
    return{
      disabled: false,
      url: '',
      file: null,
      textTips: false,//选取文件提示
      variable: '',
      num: '',
      remain: '',//预览变量
      remainParam: [],//预览变量
      mouldContent:'',//预览
      autographData: [],//签名
      sendForm: {
        isMarket:1,
        signName: '',
        orderNo: '',
        reqNo: 1,
        params: [{"value": ''}],
      },
    };
   },
  created(){
    this.url = http.httpURL;
    this.getAutographList();
    this.mouldContent = this.sendData.mouldContent
    this.computeRematn(this.sendData.mouldContent);
  },
  methods: {
    getAutographList(){//获取签名列表
      let data = {
        "start": 1,
        "length": 2000,
        "isAuditing": 0
      }
      api.autographList({data:data}).then(res => {
        if(res.status == 'success'){
          this.autographData = res.data.resultList;
        }
      })
    },
    signNameChange(v){//选取签名
      this.remaint = v;
      this.mouldContent = '【' + this.remaint + '】' + this.mouldContent;
      this.computeRematn(this.mouldContent);
    },
    computeRematn(v){
      this.remain = v.length;
      if(v.length == 0){
        this.num = 0;
      }else if(v.length > 0 & v.length < 71){
        this.num = 1;
      }else{
        this.num = Math.ceil(v.length / 67);
      }
    },
    removeDomain(index) {//删除模板参数
      this.sendForm.params.splice(index, 1);
      this.mouldContent = this.mouldContent.replace(this.remainParam[index],"{"+ (index+1)+"}" );
      this.remainParam[index] = "{"+ (index+1)+"}" ;
    },
    addDomain() {//添加模板参数
      let index = this.mouldContent.indexOf("{" + (this.sendForm.params.length + 1) + "}");
      if(index == -1){
         this.$message.error('已达最大参数个数');
         return;
      }
      this.sendForm.params.push({
        value: '',
        key: Date.now()
      });
    },

    putDomainInRematn(index){
      let startIndex = this.mouldContent.indexOf("【");
      let endIndex = this.mouldContent.indexOf("】");
      this.mouldContent = this.mouldContent.replace(this.mouldContent.substring(startIndex,endIndex+1),"");
      if(this.remainParam[index]){
        this.mouldContent = this.mouldContent.replace(this.remainParam[index],this.sendForm.params[index].value == "" ? "{"+ (index+1)+"}" : this.sendForm.params[index].value);
        this.remainParam[index] = this.sendForm.params[index].value == "" ? "{"+ (index+1)+"}" : this.sendForm.params[index].value;
       
      }else{
        this.remainParam.push(this.sendForm.params[index].value);
        startIndex = this.mouldContent.indexOf("{");
        endIndex = this.mouldContent.indexOf("}");
        this.mouldContent = this.mouldContent.replace(this.mouldContent.substring(startIndex,endIndex+1),this.remainParam[index]);
        
      }

      if(this.remaint){
        this.mouldContent = '【' + this.remaint + '】' + this.mouldContent;
      }
      this.computeRematn(this.mouldContent);
    },

    uploadQiniu(){

    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 /1024 < 1;
      if (!isLt1M) {
        this.$message.error('单次上传文件大小不能超过 1MB!');
      }else{
        this.file = file;
        this.textTips = true;
      }
      return isLt1M;
    },
    submitForm(formName){//发送
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.textTips){
            _this.disabled = true;
            let params = [];
            _this.sendForm.params.forEach(function(v,i,arr){
              params.push(v.value)
            });
            let formData = new FormData()
            formData.append('userPhoneFile',_this.file.raw);
            formData.append('mouldSign',_this.sendData.mouldSign);
            formData.append('isMarket',_this.sendForm.isMarket);
            formData.append('orderNo',_this.sendForm.orderNo);
            formData.append('reqNo',_this.sendForm.reqNo);
            formData.append('sign',_this.sendForm.signName);
            formData.append('params',params);
            axios.post('manager/send/sendMsg',formData,{headers:{'Content-Type':'multipart/form-data'}}).then(response=>{
              this.disabled = false;
              if(response.data.status == 'success'){
                this.resetMessageForm('sendMsgForm');
                this.$message.success(response.data.msg);
              }else{
                this.$message.error(response.data.msg);
              }
            })
          }else{
            this.$message.error('请先选取发送对象')
          }
        } else {
          return false;
        }
      });
    },
    resetMessageForm(formName){//取消
      this.$emit('closeSends');
      this.$refs[formName].resetFields();
    }
  },
  components: {
    
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/message/send.vue